// Generated from CloudFormation stack davax-sam-test; do not edit manually.
const config = {
  "branchName": "test",
  "deploymentDate": "21/10/26",
  "deploymentTime": "21:11:56",
  "backendDeploymentAt": "2026-10-16T20:43:08.3470000Z",
  "aws": {
    "region": "us-east-1",
    "userPoolId": "us-east-1_1KoRgobz2",
    "userPoolWebClientId": "5t8bp8a9svab70bc9b5rfhk1l0",
    "identityPoolId": "us-east-1:75345c71-6077-4338-937e-8d87b60d20f5",
    "apiEndpoint": "https://31kkrcun4l.execute-api.us-east-1.amazonaws.com/test"
  },
  "frp": {
    "bindPort": 7000,
    "tunnelHost": "tunnel.test.demo.davax-pc.com",
    "controlHost": "control.test.demo.davax-pc.com",
    "cloudFrontDomain": "d3ko91bq8qqwzv.cloudfront.net",
    "nlbDnsName": "davax-frp2-nlb-test-b1bad94116b5fe11.elb.us-east-1.amazonaws.com",
    "wildcardDemoDomain": "*.test.demo.davax-pc.com",
    "httpVhostPort": 8080
  },
  "dynamodb": {
    "demoNodesTable": "davax-demo-nodes-test",
    "demoSessionsTable": "davax-demo-sessions-test"
  },
  "ec2": {
    "securityGroupId": "sg-0af77303285b4e5ca",
    "subnetIds": [
      "subnet-0879296e8c1e2e086",
      "subnet-0edb9ddc9f93953ed"
    ],
    "launchTemplateId": "lt-03dd1f9857935a688"
  }
};
export default config;
